import Img from "../img";
import shared from "../../data/js/shared";

const {
  contactHowItWorksHeading,
  contactStepChat1,
  contactStepChat2,
  contactStepChat3,
  contactStepEmail1,
  contactStepEmail2,
  contactStepEmail3,
  secureMessagingHeading,
  secureMessagingText,
  emailPreferredHeading,
  emailPreferred,
} = shared.product;

interface ContactSellerDetailsProps {
  variant: "chat" | "email";
}

const ContactSellerDetails = ({ variant }: ContactSellerDetailsProps) => {
  const steps =
    variant === "email"
      ? [contactStepEmail1, contactStepEmail2, contactStepEmail3]
      : [contactStepChat1, contactStepChat2, contactStepChat3];

  const badgeHeading =
    variant === "email" ? emailPreferredHeading : secureMessagingHeading;
  const badgeText = variant === "email" ? emailPreferred : secureMessagingText;
  const badgeIcon =
    variant === "email"
      ? "/images/svg/envelope.svg"
      : "/images/svg/buyer-protection-badge.svg";

  return (
    <>
      <div className="contact-seller-details same-color-border">
        <h4 className="contact-seller-heading">{contactHowItWorksHeading}</h4>
        <ol className="contact-seller-steps">
          {steps.map((step, index) => (
            <li key={index}>
              <span className="contact-seller-step-number">{index + 1}</span>
              <span className="contact-seller-step-text">{step}</span>
            </li>
          ))}
        </ol>
      </div>
      <div className="contact-seller-badge same-color-border">
        <div className="image">
          <Img src={badgeIcon} />
        </div>
        <div className="text">
          <h3>{badgeHeading}</h3>
          <p>{badgeText}</p>
        </div>
      </div>
    </>
  );
};

export default ContactSellerDetails;
